import { getDate } from '@progress/kendo-date-math';
/**
 * @hidden
 */
export var isInRange = function (candidate, min, max) { return (candidate === null
    || !((min && getDate(min) > getDate(candidate))
        || (max && getDate(max) < getDate(candidate)))); };
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-dateinputs/dist/es/datepicker/utils.js
// module id = 1215
// module chunks = 0